// extracted by mini-css-extract-plugin
module.exports = {"component":"Dots_component__AtEGv","action":"Dots_action__2_v1n"};